import React, { useState, useEffect } from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { LoginMenu } from './api-authorization/LoginMenu';
import { useLocation } from 'react-router-dom';

import authService from './api-authorization/AuthorizeService';
import './NavMenu.css';

const NavMenu = () => {
    const location = useLocation();
    const [collasped, setCollasped] = useState(false);
    const [loadAuthentication, setLoadedAuthentication] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [userRole, setUserRole] = useState(null);

    const toggleNavbar = () => {
        setCollasped(!collasped)
    };

    useEffect(() => {
        if (!loadAuthentication) {
            setLoadedAuthentication(true);
            const isAuthenticated = authService.isAuthenticated()
            setIsAuthenticated(isAuthenticated)
        }
    }, [loadAuthentication]);

    useEffect(() => {
        authService.getUser().then((user) => {
            if (user) {
                setUserRole(user.role);
            }
        })

    }, [location]);

    const renderNavList = (location) => {
        const selectedPath = location.pathname.toLowerCase();
        const selectedSearch = location.search;
        if (userRole === 'Admin') {
            return <>
                <Nav.Item>
                    <Nav.Link as={Link} className={selectedPath === '/admin' ? 'active' : ''}
                              to="/admin">Home</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link as={Link} to="/admin/fixtures"
                              className={selectedPath === '/admin/fixtures' ? 'active' : ''}>Fixtures</Nav.Link>
                </Nav.Item>
            </>;
        } else {
            return <>
                <Nav.Item>
                    <Nav.Link as={Link}
                              className={selectedPath === '/home' || selectedPath === '/' || selectedPath === '' ? 'active' : ''}
                              to="/home">Home</Nav.Link>
                </Nav.Item>
                {userRole != 'Uploader' &&
                    <Nav.Item>
                        <Nav.Link as={Link} className={selectedPath === '/training' ? 'active' : ''}
                                  to="/training">Training</Nav.Link>
                    </Nav.Item>
                }
                <Nav.Item>
                    <Nav.Link as={Link} className={selectedPath === '/calendar' ? 'active' : ''}
                              to="/calendar">Calendar</Nav.Link>
                </Nav.Item>
                {userRole != 'Uploader' &&
                    <Nav.Item>
                        <Nav.Link as={Link}
                                  className={selectedPath === '/liverooms' || (selectedPath.includes('/scoring') && selectedSearch.includes('?roomActive=true')) ? 'active' : ''}
                                  to="/liverooms">Live Rooms</Nav.Link>
                    </Nav.Item>
                }
                {userRole === 'Manager' &&
                    <Nav.Item>
                        <Nav.Link as={Link}
                                  className={selectedPath === '/completed-rooms' || (selectedPath.includes('/scoring') && selectedSearch.includes('?roomActive=false')) ? 'active' : ''}
                                  to="/completed-rooms">Completed Rooms</Nav.Link>
                    </Nav.Item>
                }
            </>;
        }
    };
    const navList = renderNavList(location);
    const selectedPath = location.pathname.toLowerCase();
    return (
        <>
            {isAuthenticated &&
                <header>
                    <Navbar bg="dark" variant="dark" expand="sm"
                            style={{marginBottom: !selectedPath.includes('scoring') ? '1rem !important' : ''}}>
                        <Navbar.Brand tag={Link} href="/">
                            <img src="/assets/images/navbarlogo.png"
                                 alt=""
                                 height={36}
                                 className="d-inline-block align-text-top"></img>
                        </Navbar.Brand>
                        <Navbar.Toggle onClick={toggleNavbar} className="mr-2"/>
                        <Navbar.Collapse className="d-sm-inline-flex flex-sm-row-reverse">
                            <Nav className="flex-grow me-auto">
                                {navList}
                                <LoginMenu>
                                </LoginMenu>
                            </Nav>
                        </Navbar.Collapse>
                    </Navbar>
                </header>
            }
        </>
    );
}

NavMenu.displayName = NavMenu.name;

export default NavMenu;